export default __webpack_public_path__ + "static/media/news-02.c8f5c55a.jpg";